module.exports = __webpack_public_path__ + "img/female_resultD.604d3232.png";